import type { EmblaCarouselType } from 'embla-carousel/components/EmblaCarousel'
import { useCallback, useEffect, useState } from 'react'

export function useShowScrollButton(emblaApi?: EmblaCarouselType) {
  const [prevBtnDisabled, setPrevBtnDisabled] = useState(true)
  const [nextBtnDisabled, setNextBtnDisabled] = useState(true)

  const onPrevButtonClick = useCallback(() => {
    if (!emblaApi)
      return
    emblaApi.scrollPrev()
  }, [emblaApi])

  const onNextButtonClick = useCallback(() => {
    if (!emblaApi)
      return
    emblaApi.scrollNext()
  }, [emblaApi])

  const updateButtonStates = useCallback((api: EmblaCarouselType) => {
    setPrevBtnDisabled(!api.canScrollPrev())
    setNextBtnDisabled(!api.canScrollNext())
  }, [])

  useEffect(() => {
    if (!emblaApi)
      return

    updateButtonStates(emblaApi)

    const handleUpdate = () => updateButtonStates(emblaApi)

    emblaApi.on('reInit', handleUpdate).on('select', handleUpdate)

    return () => {
      emblaApi.off('reInit', handleUpdate).off('select', handleUpdate)
    }
  }, [emblaApi, updateButtonStates])

  return {
    prevBtnDisabled,
    nextBtnDisabled,
    onPrevButtonClick,
    onNextButtonClick,
  }
}
